import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=80210776&"
import script from "./Select.vue?vue&type=script&lang=js&"
export * from "./Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80210776')) {
      api.createRecord('80210776', component.options)
    } else {
      api.reload('80210776', component.options)
    }
    module.hot.accept("./Select.vue?vue&type=template&id=80210776&", function () {
      api.rerender('80210776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Select.vue"
export default component.exports